import { render, staticRenderFns } from "./LotteryEvents.vue?vue&type=template&id=bfcd3d5a&scoped=true&"
import script from "./LotteryEvents.vue?vue&type=script&lang=js&"
export * from "./LotteryEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcd3d5a",
  null
  
)

export default component.exports